export default __webpack_public_path__ + "static/media/CI_SNHL_IND_01.7483d5f4.jpg";